"use strict";

angular.module("core").controller("RequestPasswordResetCode", function(
    $scope, $state, $http, FlashBag, gettextCatalog, FormError, appConfig
) {
    $scope.Form = {username: null};

    $scope.validate = function($event) {
        $scope.SetPassword.$setSubmitted();
        FlashBag.clearAll();

        if ($scope.SetPassword && ($scope.SetPassword.$valid || $scope.SetPassword.Username.$error.absent)) {
            $scope.submit($event);
        }
        else {
            FormError.focus("SetPassword");
        }

        $scope.submitPassword = true;
    };

    $scope.submit = function(e) {
        e.preventDefault();
        $http({
            method: "POST",
            url: appConfig.API_SERVER + "/auth/" + appConfig.APP + "/request-reset-password-code/",
            data: $scope.Form,
            withCredentials: false
        }).then(
            function onSuccess(response) {
                $state.go("resetPassword", {username: $scope.Form.username});
                FlashBag.success(response.data, true, 0);
            },

            function onError(response) {
                FlashBag.apiError(response);


                if (!$scope.SetPassword) {
                    return;
                }

                if (response.data["username"]) {
                    $scope.SetPassword.Username.$setValidity("absent", false);
                }
                else {
                    $scope.SetPassword.Username.$setValidity("absent", true);
                }
            }
        );
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/reset-password/request-code.controller.js
// module id = 401
// module chunks = 0